export const WINDOW_EVENTS = {
  UPDATE_UNREAD_STATUS: "updateUnreadStatus",
  OPEN_PAGE_BUILDER: "openPageBuilder",
  OPEN_SUBSCRIBER_PROFILE: "openSubscriptionProfile",
  PROMPT_PUSH_PERMISSION: "promptPushPermisson",
  DIRECT_MESSAGE_SUBSCRIBER: "directMessageSubscriber",
  SUBSCRIBER_PROFILE_LOADED: "subscriberProfileLoaded",
};

export const APP_BRIDGE_MESSAGES = {
  INITIALIZE: "INITIALIZE",
  INITIALIZED: "INITIALIZED",
  SET_PROPS: "SET_PROPS",
  SET_TEMPLATE: "SET_TEMPLATE",
  SET_GLOBAL_STATE: "GLOBAL_STATE",
  SET_PATH: "SET_PATH",
  SET_LAYOUT: "SET_LAYOUT",
  BRIDGE_READY: "BRIDGE_READY",
  BLOCK_REPOSITIONED: "BLOCK_REPOSITIONED",
  SETUP_SORTING: "SETUP_SORTING",
  DRAG_TARGET_DROPPED: "DRAG_TARGET_DROPPED",
  GENERATE_IMAGE: "GENERATE_IMAGE",
  IMAGE_GENERATED: "IMAGE_GENERATED",
  COLLECTION_LOADED: "COLLECTION_LOADED",
  ADD_BLOCK: "ADD_BLOCK",
  REORDER_STARTED: "REORDER_STARTED",
  REORDER_STOPPED: "REORDER_STOPPED",
  BUILDER_VIEWPORT_MODE: "BUILDER_VIEWPORT_MODE",
};

export const BUILDER_VIEWPORT_MODES = {
  MOBILE: "mobile",
  DESKTOP: "desktop",
};

export const VIEWPORT_MODE_KEY = "MVT_builder_viewport_mode";
export const RESPONSIVE_KEY_DESKTOP = "--desktop";
export const BUILDER_PADDING_OFFSET = 8;

export const getDesktopKey = (propKey) => `${propKey}${RESPONSIVE_KEY_DESKTOP}`;
